module.exports = __webpack_public_path__ + "media/images/footer/impact-footer-0edb06273a98832cad214cba3823b0e2.svg";